export default function normalizeInputValue(inputValue) {
  return inputValue ? inputValue.toLowerCase() : "";
}